import { Box, Image, Heading } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import testimonial1 from "../assets/81054.jpg";
import testimonial2 from "../assets/81057.jpg";
import testimonial3 from "../assets/1000110270.jpg";
import testimonial4 from "../assets/1000110271.jpg";
import testimonial5 from "../assets/1000457449.jpg";
import testimonial6 from "../assets/feedback-insta.jpeg";
import testimonial7 from "../assets/IMG_5105.PNG";
import testimonial8 from "../assets/IMG_5108.PNG";

const MotionBox = motion(Box);

export default function Testimonials() {
  const testimonials = [
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,
    testimonial5,
    testimonial6,
    testimonial7,
    testimonial8,
  ];

  return (
    <Box py={20} px={{ base: 6, md: 24 }} bg="white">
      <Heading textAlign="center" mb={12} color="sedapePinkDark">
        Nossos Clientes
      </Heading>

      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        spaceBetween={24}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {testimonials.map((img, i) => (
          <SwiperSlide key={i}>
            <MotionBox
              whileHover={{ scale: 1.05, y: -5 }}
              transition={{ type: "spring", stiffness: 200, damping: 20 }}
              borderRadius="2xl"
              overflow="hidden"
              boxShadow="xl"
              mx="auto"
              maxW="500px"
            >
              <Image
                src={img}
                alt={`Cliente ${i + 1}`}
                height={{ base: "200px", md: "300px", lg: "400px" }}
                width="100%"
                objectFit="cover"
              />
            </MotionBox>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
